import React from 'react';

export default function ContactSection() {
  const whatsappUrl = 'https://wa.me/258874639388?text=Olá%2C%20Mãos%20Mágicas!%20Gostaria%20de%20fazer%20uma%20marcação.';
  const mapsUrl = 'https://maps.google.com/?q=Rua+da+Malhangalene+Maputo+Mozambique';

  return (
    <section id="contacto" className="py-24 lg:py-32" style={{ background: '#FFD6E0' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
          {/* Info */}
          <div>
            <span className="gold-line mb-6 block" />
            <p className="text-xs tracking-[0.25em] uppercase font-medium text-burnt-rose mb-4">
              Contacto
            </p>
            <h2 className="font-serif text-4xl lg:text-5xl font-light leading-[1.1] text-dark-brown mb-10">
              Estamos aqui<br />
              <em className="italic text-burnt-rose">para si.</em>
            </h2>

            <div className="space-y-6">
              {/* Address */}
              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-full bg-blush flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-burnt-rose">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                    <circle cx="12" cy="9" r="2.5"/>
                  </svg>
                </div>
                <div>
                  <p className="text-xs tracking-wide uppercase text-foreground/50 mb-1 font-medium">Morada</p>
                  <p className="text-sm text-foreground/80 leading-relaxed">
                    Rua da Malhangalene, esquina com a Rua da Resistência<br />
                    Cidade de Maputo, Moçambique
                  </p>
                  <a
                    href={mapsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs text-burnt-rose hover:underline mt-1 inline-block"
                  >
                    Ver no mapa →
                  </a>
                </div>
              </div>

              {/* Phone */}
              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-full bg-blush flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-burnt-rose">
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 .18h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
                  </svg>
                </div>
                <div>
                  <p className="text-xs tracking-wide uppercase text-foreground/50 mb-1 font-medium">Telefone & WhatsApp</p>
                  <a
                    href={whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-foreground/80 hover:text-burnt-rose transition-colors"
                  >
                    +258 87 463 9388
                  </a>
                  <p className="text-xs text-foreground/50 mt-0.5">Chamadas & WhatsApp</p>
                </div>
              </div>

              {/* Hours hint */}
              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-full bg-blush flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-burnt-rose">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12 6 12 12 16 14"/>
                  </svg>
                </div>
                <div>
                  <p className="text-xs tracking-wide uppercase text-foreground/50 mb-1 font-medium">Horário</p>
                  <p className="text-sm text-foreground/80">Segunda a Sexta: 08h00 – 18h00</p>
                  <p className="text-sm text-foreground/80">Sábado: 09h00 – 16h00</p>
                  <p className="text-sm text-foreground/50">Domingo: Encerrado</p>
                </div>
              </div>
            </div>
          </div>

          {/* Map placeholder */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden aspect-square bg-nude/30 border border-border flex flex-col items-center justify-center">
              <div className="text-center p-8">
                <div className="w-16 h-16 rounded-full bg-blush flex items-center justify-center mx-auto mb-4">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-burnt-rose">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                    <circle cx="12" cy="9" r="2.5"/>
                  </svg>
                </div>
                <p className="font-serif text-xl text-dark-brown mb-2">Mãos Mágicas</p>
                <p className="text-sm text-foreground/60 mb-6 leading-relaxed">
                  Rua da Malhangalene,<br />esquina com a Rua da Resistência<br />Maputo, Moçambique
                </p>
                <a
                  href={mapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-6 py-3 btn-outline rounded-full text-xs tracking-[0.12em] uppercase font-semibold"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3"/>
                  </svg>
                  Abrir no Google Maps
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
